(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shq-mega-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    root.querySelectorAll('.shq-mega-nav').forEach(nav => {
      if (nav.dataset.initialized) return;
      nav.dataset.initialized = 'true';
      const menus = [...nav.querySelectorAll('details')];
      const closeOthers = current => menus.forEach(menu => { if (menu !== current) menu.open = false; });
      menus.forEach(menu => {
        let timer;
        menu.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(timer);
          closeOthers(menu);
          menu.open = true;
        });
        menu.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180);
        });
        menu.addEventListener('toggle', () => { if (menu.open) closeOthers(menu); });
        menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 0));
      });
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.open);
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) closeOthers(null); });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
